import Info, { renderTitle, renderLink } from './info'

export { renderTitle, renderLink }
export default Info
